export enum WinRatioType {
    TINY = "tiny",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
    BIG_WIN = "bigWin",
    MEGA_WIN = "megaWin",
    SUPER_MEGA_WIN = "superMegaWin",
    SUPER_SUPER_MEGA_WIN = "supeSuperMegaWin",
    SUPER_DUPER_MEGA_WIN = "superDuperMegaWin"
}

export interface IWinRatioConfig {
    readonly ratio: number;
    readonly text?: string;
    readonly duration: number;
    readonly type?: WinRatioType;
}

export interface IWinRatios {
    readonly normalWin: IWinRatioConfig[];
    readonly bigWin: IWinRatioConfig[];
}